import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Avatar, Box, Typography } from '@mui/material';
import { apiBaseUrl } from '../utils/Api/Api';
import ShoppingCartElement from './building_blocks/ShoppingCartElement';
import { PageBackButton } from './building_blocks/PageHeader';
import { layoutShopSheetRadius } from '../theme/colors';

/*Icons*/
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';

function ProviderShop() {
  const location = useLocation();
  const provider = location.state;

  useEffect(() => {
    document.title = 'Informações da loja - TudoPets.app';
  }, []);

  const seconderyFont = {
    color: '#546E7A',
    fontFamily: 'Nunito',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '21px'
  }

  const containerFlex = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    alignSelf: 'stretch'
  }
  
  if (!provider) {
    return <div>Carregando...</div>;
  }

  return (
    <Box>
      <ShoppingCartElement />
      {/*provider.business_banner && 
        <Box sx={{width: "100%", height: "140px"}}>
          <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={`${apiBaseUrl}${provider.business_banner}`} />
        </Box>
      */}
      {/*Botão para retornar*/}
      <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'flex-start' }}>
        <PageBackButton onClick={() => window.history.back()} />
      </Box>

      {/*Informações da loja*/}
      <Box sx={{ display: 'flex', alignItems: 'center', borderRadius: `${layoutShopSheetRadius} ${layoutShopSheetRadius} 0 0`, bgcolor: 'surface.card', margin: 'auto -16px', flexDirection: 'column', p: 2, height: "100vh"}} > {/* Add height: "100vh" apenas por enquanto */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, mt: '-50px' }}>

          {/* Logo */}
          <Avatar sx={{ border: '1px solid lightgray', width: '80px', height: '80px', aspectRatio: '1/1' }} src={provider.business_logo && `${apiBaseUrl}${provider.business_logo}`} />

          {/*Usar ProviderShop?*/}
          {/*Nome e infos*/}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>

            {/* Nome e Bairro */}
            <Typography variant="pageTitle"><b>{provider.name}{provider.address.bairro ? ` -  ${provider.address.bairro}` : ''}</b></Typography>

            {/* Info Entrega */}
            <Typography sx={{ color: '#546E7A', fontFamily: 'Nunito', fontSize: '16px', fontStyle: 'normal', fontWeight: 400, lineHeight: '24px' }}>
              <small>1,5km &#9679; Entrega em até 24h &#9679; R$10,00</small>
            </Typography>
          </Box>
        </Box>

        {/*Endereço e Contato*/}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, alignSelf: 'stretch', flexDirection: 'column', mt: 4 }}>

          {/*Info endereço*/}
          <Box sx={{ borderTop: '1px solid', borderBottom: '1px solid', borderColor: 'divider', display: 'flex', p: '24px 0', alignItems: 'flex-start', gap: 1, alignSelf: 'stretch', flexDirection: 'column' }}>
            {/*Endereço*/}
            <Typography variant="storeName" textAlign="left"><b>Endereço</b></Typography>

            {/*Endereço completo*/}
            <Box textAlign='left' sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, alignSelf: 'stretch' }}>
              <LocationOnIcon sx={{ color: '#F8963E' }} />
              <Box>
                <Typography sx={{ ...seconderyFont }}>
                  {provider.address.logradouro}
                  {provider.address.numero ? `, ${provider.address.numero}` : ''}
                  {provider.address.bairro ? ` - ${provider.address.bairro}` : ''}
                </Typography>

                <Typography sx={{ ...seconderyFont }}>
                  {provider.address.localidade}, {provider.address.uf} - {provider.address.cep}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/*Info contato*/}
          <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, pb: 3, width: '100%' }}>
            {/*Contato*/}
            <Typography variant="storeName" textAlign="left"><b>Contato</b></Typography>

            {/*Contato Completo*/}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, alignSelf: 'stretch', width: '100%' }}>
              <Box sx={{ ...containerFlex }}>
                <PhoneInTalkIcon sx={{ color: '#F8963E' }} />
                <Typography textAlign="left" variant="body2" sx={{ ...seconderyFont }}>{provider.phone}</Typography>
              </Box>
              {/* <Box sx={{ ...containerFlex }}>
                <EmailIcon sx={{ color: '#F8963E' }} />
                <Typography textAlign="left" variant="body2" sx={{ ...seconderyFont }}>{currentUser.email}</Typography>
              </Box> */}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default ProviderShop
